import axios from "axios"
import moment from "moment/moment"

// export const baseURL = "http://localhost:5001/"
export const baseURL = "https://api-admin.closedigit.com/"

export const Dashboard = "Dashboard";
export const Invoices = "Invoices";
export const Salesinvoices = "Salesinvoices";
export const Purchaseinvoices = "Purchaseinvoices";
export const Transactions = "Transactions";
export const Shareholders = "Shareholders";
export const Spends = "Spends";
export const Clients = "Clients";
export const Messages = "Messages";
export const Create = "create";
export const Delete = "delete";
export const Update = "update";
export const View = "view";
export const Approve = "approve";
export const Reject = "reject";
export const AddSalary = "addSalary";
export const GenerateSalarySlip = "generateSalarySlip";
export const AddBankDetails = "addBankDetails";
export const Employees = "Employees";
export const Task = "Task";
export const Holiday = "Holiday";
export const Designation = "Designation";
export const Ticket = "Ticket";
export const Appreciation = "Appreciation";
export const Department = "Department";
export const TimeSheet = "TimeSheet";
export const Notice = "Notice";
export const Settings = "Settings";
export const Project = "Project";
export const Documents = "Documents";
export const Salary = "Salary";
export const Leaves = "Leaves";
export const Attendance = "Attendance";
export const Report = "Report";
export const TaskReport = "TaskReport";
export const AttendanceReport = "AttendanceReport";
export const HR = "HR";
export const Work = "Work";
export const ProjectFiles = "ProjectFiles";
export const ProjectNotes = "ProjectNotes";
export const Award = "Award";
export const Specialday = "Specialday";
export const AddSalaryRevision = "addSalaryRevision";
export const WaterJug = "WaterJug"
export const Reminders = "Reminders";

const Axios = axios.create({
    baseURL: baseURL,
});

export const DefaultCurrencykey = "default_currency"
export const api = async (url, type, data, headers, options = {}) => {
    let requestTypes = ['get', 'post', 'put', 'delete']
    let requestType = requestTypes.find((reqType) => { return reqType === type })
    if (requestType) {
        try {
            const response = await Axios({ method: requestType, url: url, data: data, headers: headers, ...options })
            return response
        } catch (e) {
            return Promise.reject(e)
        }
    } else {
        return Promise.reject("invalid request type")
    }
}

export const isValidToken = (expiryTime) => {
    const expiryMoment = moment.unix(expiryTime)
    const nowMoment = moment(new Date())
    const result = nowMoment.isBefore(expiryMoment)
    return result
}
